import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import PlusIcon from '../components/PlusIcon';
import Sidebar from '../components/Sidebar';
import TaskList from '../components/TaskList';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <div className="container relative">
        <Sidebar />

        <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
          <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
            <div className="justify-between mb-10 space-y-2 md:flex md:space-y-0">
              <Link to="/add" className="lws-addnew group">
                <PlusIcon />
                <span className="group-hover:text-indigo-500">Add New</span>
              </Link>
            </div>

            <TaskList />
          </main>
        </div>
      </div>
    </>
  );
};

export default HomePage;
